export default "__VITE_ASSET__CPa_kuVA__"